import { memoize } from "lodash";
import { utilBalancing } from "../utils/utilBalancing";
export var selectCoopProjects = memoize(function () { return Array.from(utilBalancing.getBalancing().CoopProjects.values()); });
export var selectCoopProjectType = memoize(function (projectTypeId) {
    var projects = selectCoopProjects();
    var projectType;
    if (projects && projects.length > 0 && projectTypeId > -1) {
        projectType = projects.find(function (project) { return project.id === projectTypeId; });
    }
    return projectType;
});
export var balancingCoopProjectsMemoizedFunctions = [selectCoopProjects, selectCoopProjectType];



//////////////////
// WEBPACK FOOTER
// ./src/balancingSelectors/selectBalancingCoopProjects.ts
// module id = 232
// module chunks = 3